/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
* Copyright 2023 Adobe
* All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/

"use client";

import { Button, Flex, Text, View } from "@adobe/react-spectrum";

import style from './side-panel-action.module.scss'
import QRModal from "@/components/QRModal/Modal";
import { useEffect, useState } from "react";
import ShareSheet from "@/components/Sharesheet";
import { sendAdobeAnalyticsTryNowEvent } from '@/utils/utils';
import { usePathname } from "next/navigation";
import { generateBranchDeepLink } from "@/utils/utils";
import { useTranslations } from "next-intl";

export default function SidePanelAction({ locale, like_count }) {
    const [modal, setModal] = useState(false);
    const path = usePathname();
    const t = useTranslations("");
    const routes: Array<string> = path.split("/");

    useEffect(() => {
    }, [routes])

    const handleModal = () => {
        const userAgent = navigator.userAgent;
        if (/iPad|iPhone|iPod/i.test(userAgent)) {
            generateBranchDeepLink(routes[routes.length - 1]);
        }
        else if (/android/i.test(userAgent)) {
            generateBranchDeepLink(routes[routes.length - 1]);
        } else
            setModal(!modal);
    }


    const handleTryNow = () => {
        const initiatingSource = 'AssestScreen';
        sendAdobeAnalyticsTryNowEvent(initiatingSource);
        handleModal();
    }

    return <View>
        <Flex columnGap={10} UNSAFE_className={style.innerDiv}>
            <Button variant="cta" onPress={handleTryNow} UNSAFE_className={style.tryNowButton}>
                {t("try_now")}
            </Button>
            <View>
                <ShareSheet />
            </View>
            <View alignSelf={"center"} marginBottom={3}>
                <Text UNSAFE_className={style.likeBtn}>{t("like_Count")} </Text>
                <Text UNSAFE_className={style.likeCount}>{like_count} </Text>
            </View>

        </Flex>
        <QRModal open={modal} setOpen={handleModal} lang={locale} />
    </View>
}